import { ChangeDetectorRef, Component, OnInit, TemplateRef,EventEmitter } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {FormBuilder, FormControl, FormGroup} from '@angular/forms';
import {Observable, Subscription} from 'rxjs';
import {map, startWith} from 'rxjs/operators';
import { Router } from '@angular/router';
import { DataSharingService } from 'src/app/middleware/common/resuableServices/data-sharing.service';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import { ToastrService } from 'ngx-toastr';
import { FileManagerService } from './services/fileManager.services';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import * as jwt_decode from 'jwt-decode';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';

export interface State {
  name: string;
  email: string;
  role: string;
  pic: string,
}

@Component({
  selector: 'app-file-manager',
  templateUrl: './file-manager.component.html',
  styleUrls: ['./file-manager.component.scss']
})
export class FileManagerComponent implements OnInit {

  databaseId:any;
  organizationId:string;
  currentUser: any;

  docDetail:boolean = false;
  showmyDrive:boolean = false;
  addNote:boolean = false;
  value = '';
  stateCtrl = new FormControl();
  filteredStates: Observable<State[]>;

  permissionAsssign: any[] = [];
  folderList: any[] = [];
  clickEventsubscription: Subscription;
  fileManagerItemID:number=0;
  formDialog: FormGroup;  
  
  
OfficeIDList: any=[];
myOfficeID: any;


getSharedWithMe() {
  sessionStorage.setItem('FileManagerMenuActive','false');
  sessionStorage.setItem('FileManagerMenuSharedActive','true');
  sessionStorage.setItem('isSharedWithMeFileManager','false');    
  this._dataSharingService.sendSelectedFolderDetailsFromLeftMenuFileManager(null);
  this._dataSharingService.sendSelectedFolderContentFromLeftMenuFileManager("sharewithme");
}


  constructor(private dialog: MatDialog, private router: Router,
    private _dataSharingService: DataSharingService,private cdr: ChangeDetectorRef,
    private formBuilder: FormBuilder, private reusableClass: ReusableClasses,
    private toastr: ToastrService, private fileManagerService: FileManagerService,
    private encryptionAlgo: EncryptionService,private statusConst: StatusConstant) {
      const encryptedtoken = sessionStorage.getItem('userToken');
      const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
      this.databaseId = sessionStorage.getItem('databaseId');
      this.organizationId = sessionStorage.getItem('organizationID');
      this.currentUser = jwt_decode(token);
    this.filteredStates = this.stateCtrl.valueChanges.pipe(startWith(''),
      map(state => state ? this._filterStates(state) : this.states.slice())
    );
    
    var offices=JSON.parse(sessionStorage.getItem('officeList'));
    offices.forEach(oe => {
    this.OfficeIDList.push(oe.officeID)	
    if(oe.isMyoffice==true)
      this.myOfficeID=oe.officeID;
    });
   }

   private _filterStates(value: string): State[] {
    const filterValue = value.toLowerCase();
    return this.states.filter(state => state.name.toLowerCase().indexOf(filterValue) === 0);
  }

  ngOnInit(): void {
    // this.permissionAsssign = JSON.parse(sessionStorage.getItem("permissions")); 
    // this.permissionAsssign =this.permissionAsssign.filter((x) => x.permissionName.toLowerCase() == 'menu file manager');
    // if(this.permissionAsssign.length == 0){
    //    this.router.navigate(['unauthorised']);
    //   return;
    // }
    sessionStorage.setItem('edashboard', "false");
    this.permissionAsssign = JSON.parse(sessionStorage.getItem("menuModules"));  
    this.permissionAsssign =this.permissionAsssign.filter((x) => x.mainModuleName == 'File Manager' && x.isAssign==true);
    if(this.permissionAsssign.length == 0){
      this.router.navigate(['unauthorised']);
      return;
    }

    this.clickEventsubscription = this._dataSharingService.GetSelectedFolderIDForAddFolder().subscribe((result) => {
      if (result != '' && result != undefined) {
        this.fileManagerItemID=result;
        }else{
          this.fileManagerItemID=0;
        }
      });
    
    let groupaddtouchtype = {};
    this.formDialog = new FormGroup(groupaddtouchtype);
    this.formDialog.addControl('filemanagerFolderName', this.formBuilder.control('')); 
    sessionStorage.setItem('HeaderModuleName', 'File Manager');
    this._dataSharingService.sendSelectedModuleName('File Manager');   
    this.cdr.detectChanges();
  }

  states: State[] = [
    {
      name: 'Abbott',
      email: 'Abbott@gmail.com',
      role: 'agent',
      pic: '../../../../../assets/images/avatars/Abbott.jpg'
    },
    {
      name: 'Alice',
      email: 'alice.@gmail.com',
      role: 'agent',
      pic: '../../../../../assets/images/avatars/alice.jpg'
    },
    {
      name: 'Carl',
      email: 'carl@gmail.com',
      role: 'agent',
      pic: '../../../../../assets/images/avatars/carl.jpg'
    },
    {
      name: 'Jane',
      email: 'jane@gmail.com',
      role: 'agent',
      pic: '../../../../../assets/images/avatars/jane.jpg'
    },
    {
      name: 'Tillman',
      email: 'tillman.@gmail.com',
      role: 'agent',
      pic: '../../../../../assets/images/avatars/Tillman.jpg'
    },
    {
      name: 'Josefina',
      email: 'Josefina@gmail.com',
      role: 'agent',
      pic: '../../../../../assets/images/avatars/Josefina.jpg'
    },
    {
      name: 'Create New',
      email: ' ',
      role: ' ',
      pic: ' '
    },

  ];

  showDocDetail(){
    this.docDetail = !this.docDetail
  }

  showMyDrive(){
    this.showmyDrive = !this.showmyDrive
  }

  addNewNote(){
    this.addNote = !this.addNote
  }
 
  addFolder(templateRef: TemplateRef<any>) {
    const dialogRef = this.dialog.open(templateRef,{
      panelClass: 'custom-modalbox'
    });   
  }
  
  openCreateFolderDialogue(templateRef: TemplateRef<any>) {
    this.dialog.open(templateRef);
  }


  fileToUpload: File = null;  
  handleFileInput(files: FileList) {
    this.fileToUpload = files.item(0);
    this.addFileManagerFile();
  }

  addFileManagerFile(){
    this.cdr.detectChanges();
    this.clickEventsubscription = this._dataSharingService.GetSelectedFolderIDForAddFolder().subscribe((result) => {
      if (result != '' && result != undefined) {
        this.fileManagerItemID=result;
        }else{
          this.fileManagerItemID=0;
        }
      });
     
    const formData: FormData = new FormData();
    formData.append('FileManagerItemID', "0");
    formData.append('name', this.fileToUpload.name);
    formData.append('fileType', this.fileToUpload.type);
    formData.append('file', this.fileToUpload); 
    formData.append('officeID', this.myOfficeID);
    formData.append("parentID",this.fileManagerItemID.toString());
    formData.append("organizationID",this.organizationId.toString());
    formData.append("databaseID",this.databaseId.toString());
    formData.append("userID",this.currentUser.UID) ;
    this.fileManagerService.addFilemanagerFile(formData).subscribe(
      response=>{
          if(response!=undefined){
            var responseHolder = response;
            if (responseHolder.data ==true && responseHolder.status == this.statusConst.statusSuccess) {        
              this._dataSharingService.sendRefreshListForFileManager(true);
              this._dataSharingService.sendRefreshListForFileManagerAddFolder(this.fileManagerItemID);
              this.formDialog.reset();
              this.dialog.closeAll();
              this.toastr.success('Folder Created successfully.', '', {
                timeOut: 3000,
              });     
            }
            if (responseHolder.data == false && responseHolder.status == 500) {
             this.toastr.warning('Folder Name Already Exist.', '', {
               timeOut: 3000,
             });
          }
      }
    });

  }

  AddFolderName(data){
    let request = {
      fileManagerItemID: 0,
      name:  data.filemanagerFolderName.trim(),
      parentID: this.fileManagerItemID,
      isFile:false,
      organizationID: Number(this.organizationId),
      databaseID: parseInt(this.databaseId),
      UserId: this.currentUser.UID,
      OfficeID:this.myOfficeID      
   }
   this.fileManagerService.addFolderinFileManager(request).subscribe(response => {
     if (response != undefined) {
       var responseHolder = response;
       if (responseHolder.data == true && responseHolder.status == this.statusConst.statusSuccess) {        
         this._dataSharingService.sendRefreshListForFileManager(true);
         this._dataSharingService.sendRefreshListForFileManagerAddFolder(this.fileManagerItemID);
         this.formDialog.reset();
         this.dialog.closeAll();
         this.toastr.success('Folder created successfully.', '', {
           timeOut: 3000,
         });     
       }
       if (responseHolder.data == 2 && responseHolder.status == this.statusConst.statusSuccess) {
        this.toastr.warning('Folder name already exist.', '', {
          timeOut: 3000,
        });
       }        
     }
   });
  }

  close() {
    this.dialog.closeAll();
  } 


  

  peoples =[
    {
      name : 'Katina',
      email: 'Katina@gmail.com',
      img: 'Katina.jpg',       
    },
    {
      name : 'joyce',
      email: 'joyce@gmail.com',
      img: 'joyce.jpg',       
    },
    {
      name : 'Christy',
      email: 'Christy@gmail.com',
      img: 'Christy.jpg',       
    },
    {
      name : 'garry',
      email: 'garry@gmail.com',
      img: 'garry.jpg',       
    },
    {
      name : 'Barrera',
      email: 'Barrera@gmail.com',
      img: 'Barrera.jpg',       
    },
    
    
  ]



}
